import {axios as http} from "@/plugins/http"
import QuerySerializer from "@/services/QuerySerializer";

export default class Api {
    static delete(
        wishId,
        shopId,
    ) {
        return http.post("/api/v1/wishlist/delete-wish-link", null, {
            params: {
                wish_id: wishId,
                shop_id: shopId,
            },
            paramsSerializer: (params) => QuerySerializer.stringify(params),
        }).then((resp) => {
            return resp.data;
        });
    }
}
